import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { useState } from "react";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Link } from "react-router-dom";
function Home () {
    // Countdown
  const [day1, setDay1] = useState(0);
  const [day2, setDay2] = useState(0);

  const [hour1, setHour1] = useState(0);
  const [hour2, setHour2] = useState(0);
  const [hour3, setHour3] = useState(0);

  const [minute1, setMinute1] = useState(0);
  const [minute2, setMinute2] = useState(0);

  const [second1, setSecond1] = useState(0);
  const [second2, setSecond2] = useState(0);

  // Timer
  const countDown = () => {
    const dueDate = new Date("Feb 28, 2022 00:00").getTime();
    const currentDate = new Date().getTime();

    const remainings = dueDate - currentDate;

    if (remainings > 0) {
      let second = 1000;
      let minute = second * 60;
      let hour = minute * 60;
      let day = hour * 24;

      // Remainings
      let remainingDay = Math.floor(remainings / day);
      let remainingHour = Math.floor((remainings % day) / hour);
      let remainingMinute = Math.floor((remainings % hour) / minute);
      let remainingSecond = Math.floor((remainings % minute) / second);

      // Day
      let dayLength = remainingDay.toString().length;

      if (dayLength === 1) {
        setDay1(0);
        setDay2(remainingDay);
      } else if (dayLength === 2) {
        remainingDay = remainingDay.toString().split("");

        setDay1(remainingDay[0]);
        setDay2(remainingDay[1]);
      }

      // Hour
      let hourLength = remainingHour.toString().length;

      if (hourLength === 1) {
        setHour1(0);
        setHour2(remainingHour);
      } else if (hourLength === 2) {
        remainingHour = remainingHour.toString().split("");

        setHour1(remainingHour[0]);
        setHour2(remainingHour[1]);
      }

      // Minute
      let minuteLength = remainingMinute.toString().length;

      if (minuteLength === 1) {
        setMinute1(0);
        setMinute2(remainingMinute);
      } else if (minuteLength === 2) {
        remainingMinute = remainingMinute.toString().split("");

        setMinute1(remainingMinute[0]);
        setMinute2(remainingMinute[1]);
      }

      // Second
      let secondLength = remainingSecond.toString().length;

      if (secondLength === 1) {
        setSecond1(0);
        setSecond2(remainingSecond);
      } else if (secondLength === 2) {
        remainingSecond = remainingSecond.toString().split("");

        setSecond1(remainingSecond[0]);
        setSecond2(remainingSecond[1]);
      }
    } else {
      setDay1(0);
      setDay2(0);

      setHour1(0);
      setHour2(0);

      setMinute1(0);
      setMinute2(0);

      setSecond1(0);
      setSecond2(0);
    }
  };

  setInterval(countDown, 1000);
    return (
        // <!-- ====================Banner================= -->
        <>
            <div className="banner">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-content-wrapper">
                                <div className="banner-content">
                                    {/* <h4 className="sm-title">Buying  Selling NFT World</h4> */}
                                    <h1 className="banner-title">
                                    Discover, collect, and sell extraordinary NFTs
                                    </h1>
                                    <p className="banner-des">
                                    Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.
                                    </p>

                                    <div className="banner-button-area">
                                        <a href="" className="custom-btn me-2"><span>Explore More</span></a>
                                        <a href="" className="custom-btn-alt"> <span>Get Started</span> </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-img">
                                <img src="assets/img/banner/1.jpg" alt="banner-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- ====================Banner end================= --> */}
            {/* // ==============expolor product============= */}
            <div className="expolor-product">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <h2>Explore Products</h2>
                            <a href="" className="see-more-btn">Explore more</a>
                        </div>
                    </div>
                    <div className="row">
                    <div className="service-boxes">
                            <Swiper
                                spaceBetween={10}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                breakpoints={{
                                    450: {
                                        slidesPerView: 1.4,
                                      },
                                      680: {
                                        slidesPerView: 2,
                                      },
                                    1050: {
                                      slidesPerView: 3,
                                    },
                                    1400: {
                                        slidesPerView: 4,
                                      },
                                    
                                  }}
                                >
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <Link to="/item">
                                                        <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    </Link>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/2.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/8.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/3.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/8.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/4.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/10.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/5.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/6.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/12.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
						</div>
                    </div>
                </div>
            </div>
            {/* // ==============expolor product============= */}
            {/* ====================top collection=================== */}
            <div className="top-collection cpt-6">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <h2>Top Collections In 1 day</h2>
                            <div className="slider-nav">
                            <div className="prev"><i className="icofont-arrow-left"></i></div>
                            <div className="next"><i className="icofont-arrow-right"></i></div>
                            </div>
                        </div>
                    </div>
                    <div className="top-collection-arefa cpy-5">
                        <div className="top-collection-slider">
                        <Swiper
                                spaceBetween={20}
                                slidesPerView={2.3}
                                loop={true}
                                navigation={{
                                    prevEl: '.prev',
                                    nextEl: '.next',
                                  }}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                breakpoints={{
                                    450: {
                                      slidesPerView: 3,
                                    },
                                    540: {
                                        slidesPerView: 4,
                                      },
                                    740: {
                                        slidesPerView:5
                                    },
                                    800: {
                                        slidesPerView:6
                                    },
                                    1050: {
                                      slidesPerView: 7,
                                    },
                                    1400: {
                                        slidesPerView: 9,
                                      },
                                    
                                  }}
                                >


                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/1.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/2.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/3.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/4.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/5.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/6.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/7.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/8.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/9.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/1.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/1.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="top-collection-item">
                                        <div className="top-collection-image">
                                            <a href="" className="top-collection-link"> 
                                                <div className="top-product-img">
                                                <img src="assets/img/top/1.png" alt="" className="top-collection-img" />
                                                <div className="varified"><i className="icofont-verification-check"></i></div>
                                                </div>
                                                <div className="top-collection-details">
                                                    <p className="top-collection-name">Crispin Berry</p>
                                                    <p className="top-collection-price">$9,15485</p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                
                                
                            </Swiper>
                        </div>
                    </div>
                </div>
            </div>
            {/* ====================top collection end =================== */}
            {/* =====================newest item=================== */}
            <div className="expolor-product cpy-5">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <h2>Top Collections In 1 day</h2>
                        </div>
                    </div>
                    <div className="row">
                    <div className="service-boxes">
                            <Swiper
                                spaceBetween={10}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                breakpoints={{
                                    450: {
                                        slidesPerView: 1.4,
                                      },
                                      680: {
                                        slidesPerView: 2,
                                      },
                                    1050: {
                                      slidesPerView: 3,
                                    },
                                    1400: {
                                        slidesPerView: 4,
                                      },
                                    
                                  }}
                                >
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/6.png" alt="" className="product"/>
                                        </a>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Space babe - Night 2/25”</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                    Price
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/7.png" alt="" className="product"/>
                                        </a>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Space babe - Night 2/25”</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                    Price
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/8.png" alt="" className="product"/>
                                        </a>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Space babe - Night 2/25”</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                    Price
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/9.png" alt="" className="product"/>
                                        </a>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Space babe - Night 2/25”</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                    Price
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                
                            </Swiper>
						</div>
                    </div>
                </div>
            </div>
            {/* =====================newest item end=================== */}
            {/* <!-- ===========create nft============= --> */}
        <section>
            <div className="create-nft">
                <div className="container">
                    <div className="row">
                        <div className="sec-top">
                            <h2 className="sec-title">Create and sell your NFTs</h2>
                        </div>
                    </div>
                    <div className="px-2">
                        <div className="row">
                            <div className="col-md-6 col-xl-4 mb-4">
                                <div className="nft-card">
                                    <img src="assets/img/collection/11.png" alt="Image not found"/>
                                    <div className="nft-card-info">
                                        <p className="cat-na">Strategy</p>
                                        <h3 className="card-title">World of Deafish Lands</h3>
                                        <a href="" className="view-btn">View item on saie</a>
                                        <a href="" className="view-btn">Visit Website</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mb-4">
                                <div className="nft-card">
                                    <img src="assets/img/collection/12.png" alt="Image not found"/>
                                    <div className="nft-card-info">
                                        <p className="cat-na">Strategy</p>
                                        <h3 className="card-title">Creative Art Collection</h3>
                                        <a href="" className="view-btn">View item on saie</a>
                                        <a href="" className="view-btn">Visit Website</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mb-4">
                                <div className="nft-card">
                                    <img src="assets/img/collection/13.png" alt="Image not found"/>
                                    <div className="nft-card-info">
                                        <p className="cat-na">Strategy</p>
                                        <h3 className="card-title">Colorful Abstract</h3>
                                        <a href="" className="view-btn">View item on saie</a>
                                        <a href="" className="view-btn">Visit Website</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mb-4">
                                <div className="nft-card">
                                    <img src="assets/img/collection/14.png" alt="Image not found"/>
                                    <div className="nft-card-info">
                                        <p className="cat-na">Strategy</p>
                                        <h3 className="card-title">Creative Art collection</h3>
                                        <a href="" className="view-btn">View item on saie</a>
                                        <a href="" className="view-btn">Visit Website</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mb-4">
                                <div className="nft-card">
                                    <img src="assets/img/collection/15.png" alt="Image not found"/>
                                    <div className="nft-card-info">
                                        <p className="cat-na">Strategy</p>
                                        <h3 className="card-title">Modern Art collection</h3>
                                        <a href="" className="view-btn">View item on saie</a>
                                        <a href="" className="view-btn">Visit Website</a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mb-4">
                                <div className="nft-card">
                                    <img src="assets/img/collection/16.png" alt="Image not found"/>
                                    <div className="nft-card-info">
                                        <p className="cat-na">Strategy</p>
                                        <h3 className="card-title">Colorful Abstract</h3>
                                        <a href="" className="view-btn">View item on saie</a>
                                        <a href="" className="view-btn">Visit Website</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="load-more-area mt-4">
                            <a href="" className="custom-btn"><span>Load More</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- ===========create nft end============= --> */}
        {/* // ==============expolor product============= */}
        <div className="expolor-product cpy-6">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <h2>Live Action</h2>
                        </div>
                    </div>
                    <div className="row">
                    <div className="service-boxes">
                            <Swiper
                                spaceBetween={10}
                                slidesPerView={1}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                breakpoints={{
                                    450: {
                                        slidesPerView: 1.4,
                                      },
                                      680: {
                                        slidesPerView: 2,
                                      },
                                    1050: {
                                      slidesPerView: 3,
                                    },
                                    1400: {
                                        slidesPerView: 4,
                                      },
                                    
                                  }}
                                >
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/1.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/7.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/2.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/8.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/3.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/8.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="product-card">
                                        <div className="product-image">
                                        <a href="" className="product-link">
                                            <img src="assets/img/product/4.png" alt="" className="product"/>
                                        </a>
                                        <div className="coutn-timer">
                                            <img src="assets/img/icon/fire.svg" alt="" />
                                            <div className="count-part">
                                                <span>{day1}</span>
                                                <span>{day2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{hour1}</span>
                                                <span>{hour2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{minute1}</span>
                                                <span>{minute2}</span>
                                            </div>
                                            <span>:</span>
                                            <div className="count-part">
                                                <span>{second1}</span>
                                                <span>{second2}</span>
                                            </div>
                                        </div>
                                        <a href="" className="like-btn"><i className="icofont-ui-love"></i> 160</a>
                                        <a href="" className="bid-btn"><img src="assets/img/icon/bag.svg" alt="" /> <span>Place Bid</span></a>
                                        </div>
                                        <div className="product-des">
                                            <div className="name-diamond">
                                                <div className="name-cat">
                                                    <a href="#" className="product-name">"Hamlet Contemplates ...</a>
                                                    <p className="token-type">BSC</p>
                                                </div>

                                            </div>

                                            <div className="buy-like">
                                            <div className="author-info">
                                                <img src="assets/img/inner/10.jpg" alt="" className="author-img" />
                                                <div className="author-name-type">
                                                    <p className="author-type">Creator</p>
                                                    <a href="" className="creator-profile">SalvadorDali</a>
                                                </div>
                                            </div>
                                                <div className="price-area">
                                                    <p className="price-type">
                                                        Current Bid
                                                    </p>
                                                    <p className="price"> 4.89 eTH</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                
                            </Swiper>
						</div>
                    </div>
                </div>
        </div>
        {/* // ==============expolor product============= */}

        {/* // ==============expolor product============= */}
        <div className="expolor-product">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <h2>Create and sell your NFTs</h2>
                        </div>
                    </div>
                    <div className="row">
                    <div className="service-boxes">
                            <Swiper
                                spaceBetween={10}
                                slidesPerView={1}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                breakpoints={{
                                    450: {
                                      slidesPerView: 1.4,
                                    },
                                    600: {
                                      slidesPerView: 2,
                                    },
                                    1050: {
                                        slidesPerView: 3,
                                      },
                                    1400: {
                                        slidesPerView: 4,
                                      },
                                    
                                  }}
                                >
                                <SwiperSlide>
                                <div className="feature-card">
                                        <div className="top-icon">
                                            <img src="assets/img/icon/5.svg" alt=""/>
                                        </div>
                                        <div className="feature-card-content">
                                            <h2>
                                                Set up your wallet
                                            </h2>
                                            
                                            <p>
                                                Powerful features and inclusions, which makes Nuron standout, easily customizable and scalable.
                                            </p>
                                        </div>
                                        
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                <div className="feature-card">
                                        <div className="top-icon">
                                            <img src="assets/img/icon/2.svg" alt=""/>
                                        </div>
                                        <div className="feature-card-content">
                                            <h2>
                                                Create your collection
                                            </h2>
                                            
                                            <p>
                                                A great collection of beautiful website templates for your need. Choose the best suitable template.
                                            </p>
                                        </div>
                                        

                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                <div className="feature-card">
                                        <div className="top-icon">
                                            <img src="assets/img/icon/3.svg" alt=""/>
                                        </div>
                                        <div className="feature-card-content">
                                            <h2>
                                                Add Your NFTs
                                            </h2>
                                            
                                            <p>
                                                Sed ut perspiciatis un de omnis iste natus error sit voluptatem accusantium doloremque.
                                            </p>
                                        </div>
                                        
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                <div className="feature-card">
                                        <div className="top-icon">
                                            <img src="assets/img/icon/4.svg" alt=""/>
                                        </div>
                                        <div className="feature-card-content">
                                            <h2>
                                                List Them For Sale
                                            </h2>
                                            
                                            <p>
                                                I throw myself down among the tall grass by the stream as I lie close to the earth NFT's doloremque.
                                            </p>
                                        </div>
                                        
                                    </div>
                                </SwiperSlide>
                                
                            </Swiper>
						</div>
                    </div>
                </div>
        </div>
        {/* // ==============expolor product============= */}

        
        </>

    );
}
export default Home;